import {
  colors,
  getBorderRadius,
  getHeight,
  getSpacing,
} from '@cabonline/ui-shared';
import styled from '@emotion/styled';
import { useLocale } from '@multiplatform-apps/service-trips';
import { useDeviceType } from '../../hooks';
import { FC } from 'react';
import { NavLink } from 'react-router-dom';

import Logo from '../../../assets/logo.svg';
import { DesktopNavbar } from './desktop-navbar';
import { MobileNavbar } from './mobile-navbar';
import { TabletNavbar } from './tablet-navbar';

interface StyledNavBarProps {
  isMobile: boolean;
}

const StyledNavBar = styled.nav<StyledNavBarProps>`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  flex-direction: ${(props) => (props.isMobile ? 'column' : 'row')};
`;

const StyledHeaderContainer = styled.div`
  background-color: ${colors.black};
  padding: 0 ${getSpacing('m')};
  width: 100%;
  height: ${getHeight('l')};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledNavLink = styled(NavLink)`
  border-radius: ${getBorderRadius('m')};
  padding: ${getSpacing('xxs')};
  &:focus {
    border: 1px solid ${colors.white};
    outline: none;
  }
`;

export const NavBar: FC = () => {
  const deviceType = useDeviceType();
  const { t } = useLocale();

  const getNavBar = () => {
    if (deviceType === 'tablet' || deviceType === 'desktop') {
      return (
        <StyledHeaderContainer>
          <StyledNavLink to="/">
            <Logo height={48} aria-label={t('cabonlineLogo')} data-testid="cabonline-logo" />
          </StyledNavLink>
          {deviceType === 'tablet' ? <TabletNavbar /> : <DesktopNavbar />}
        </StyledHeaderContainer>
      );
    } else {
      return (
        <>
          <StyledHeaderContainer>
            <StyledNavLink to="/">
              <Logo height={48} aria-label={t('cabonlineLogo')} data-testid="cabonline-logo" />
            </StyledNavLink>
          </StyledHeaderContainer>
          <MobileNavbar />
        </>
      );
    }
  };

  return (
    <StyledNavBar
      aria-label="Main navigation"
      isMobile={deviceType === 'mobile'}
      data-testid="navbar"
    >
      {getNavBar()}
    </StyledNavBar>
  );
};
